import { Component, OnInit, PLATFORM_ID, ChangeDetectionStrategy, inject } from '@angular/core';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../shared/components/header/header.component';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, NgClass, RouterOutlet]
})
export class WrapperComponent implements OnInit {
    private platformId = inject<object>(PLATFORM_ID);
    private router = inject(Router);

    public isPlatformBrowser: boolean = false;
    isFixed: boolean = false;
    routesFixed: string[] = ['/project/'];

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.isPlatformBrowser = true;
            this.isFixed = this.routesFixed.some(route => this.router.url.includes(route));
    
        }
    }
    

   
}
